import axios from 'axios';

// Determine if we should use HTTPS for API URLs
const determineApiUrl = () => {
  // Check if we're in production environment and on HTTPS
  if (window.location.protocol === 'https:' && window.location.host === 'crm.sumaroh.com') {
    // Use the HTTPS version of the API
    return 'https://crm-api.sumaroh.com';
  }
  // Otherwise use the configured API URL
  return process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCALHOST_URL;
};

const api = axios.create({
  baseURL: determineApiUrl()
});

// Add a request interceptor to add the Firebase token
api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('firebaseToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized error (e.g., redirect to login)
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const getLeadsWithRequirements = (params = {}) => api.get('/api/leads/with-requirements', { params });

export default api;
